import { Injectable } from '@angular/core';

import { WindowService } from 'app/shared/window.service';
import { SISTEMAS } from 'app/config';

import { DadosPagamento } from 'models/dados-pagamento';

@Injectable()
export class BoletoService {
  constructor(private window: WindowService) { }

  private _gerarPDF(url: string) {
    if (url) {
      this.window.nativeWindow.open(url, '_blank');
    }
  }

  gerarPDF(dadosPagamentoLocal: DadosPagamento) {
    //console.log('aqui');
    const { dadosPessoais, sistema } = dadosPagamentoLocal;
    const newSistema = SISTEMAS.filter(s => s.codigoSistema === sistema.codigoSistema);
    if (newSistema.length > 0) {

      let urlBoleto = newSistema[0].urlBoleto;

      if (sistema.codigoSistema === 1 || sistema.codigoSistema === 99) {
        urlBoleto += `&numInscricaoVestibular=${dadosPessoais.numInscricao}`;
      } else if (sistema.codigoSistema === 2 || sistema.codigoSistema === 4) {
        urlBoleto += `&cpd=${dadosPessoais.cpd}&anoBol=${dadosPessoais.anoSem}&codBol=01`;
      } else if (sistema.codigoSistema === 5) {
        urlBoleto += `&cpd=${dadosPessoais.numInscricao}`;
      }

      this._gerarPDF(urlBoleto);
    }
  }
}


